/* eslint-disable @typescript-eslint/no-explicit-any */
import { isAxiosError } from 'axios';
import hwaxios from '../../../rmsReduxStore/api-service/HWAxios';
import { acReportTypes } from '../acReduxExports'
// import rmsStore from '../../../rmsReduxStore/rmsStore';
// import { isEqual } from 'lodash';
// import rmsStore from '../../../rmsReduxStore/rmsStore';
// import {isEqual } from 'lodash';
const url = process.env.REACT_APP_SERVER_BASE_URL_AC


export const fetchAcChargingHistoryReportData: any = (reqBody: unknown) => async (dispatch: (arg0: Partial<AcReportAction>) => void): Promise<void> => {
    try {
        const loaderStartAction: Partial<AcReportAction> = {
            type: acReportTypes.SET_AC_REPORT_LOADER,
            reportLoader: true
        }
        dispatch(loaderStartAction);
        const response = await hwaxios.post( url +'/report/charger/history', reqBody)     
        const action: Partial<AcReportAction> = {
            type: acReportTypes.FETCH_AC_CHARGERS_HISTORY_DATA,
            chargingHistoryColumnHeaders: response.data?.columns,
            chargingHistoryData: response.data?.data?.history,
            chargingHistoryCount: response.data?.data?.count,
        }
        dispatch(action)
        if (response?.status === 200) {
            const loaderEndAction: Partial<AcReportAction> = {
                type: acReportTypes.SET_AC_REPORT_LOADER,
                reportLoader: false
            }
            dispatch(loaderEndAction);
        }
    } catch (error) {
      const loaderEndAction: Partial<UserAction> = {
    type: acReportTypes.SET_AC_REPORT_LOADER,
    loader: false
}

        dispatch(loaderEndAction);
        console.error(error)
        throw error
    }
}

export const exportAcChargingHistoryReport: any = (reqParams: unknown) => async () => {
    try {
        const { data, status } = await hwaxios.post( url +'/report/charger/history/export', reqParams)       
        return { data, status };
    } catch (error) {
        if (isAxiosError(error)) {
            if (error.response) {
                const data = error.response.data;
                const status = error.response.status;
                return { data, status };
            }
        } else {
            return {
                data: 'Something went wrong', status: 400
            }
        }
    }
}

export const fetchAcChargerLogsData: any = (reqBody: any) => async (dispatch: (arg0: Partial<AcReportAction>) => void): Promise<void> => {
    try {
        const loaderStartAction: Partial<AcReportAction> = {
            type: acReportTypes.SET_AC_REPORT_LOADER,
            reportLoader: true
        }
        dispatch(loaderStartAction);

        const filtersHash = reqBody?.filters
        const hashAction : Partial<AcReportAction> = {
          type : acReportTypes.SET_AC_CHARGER_LOGS_LIST_REQUEST_HASH,
          chargerLogsFiltersRequestHash : filtersHash
        }
        dispatch(hashAction)
        const response = await hwaxios.post(url + '/report/charging/history', reqBody)
         
     

            const action: Partial<AcReportAction> = {
                type: acReportTypes.FETCH_AC_CHARGER_LOGS_DATA,
                chargerLogsColumnHeaders: response.data?.columns,
                chargerLogsData: response.data?.data?.history ?? response?.data?.data?.latest,
                chargerLogsCount: response.data?.data?.count,
            }
            dispatch(action)
        

        if (response?.status === 200) {
            const loaderEndAction: Partial<AcReportAction> = {
                type: acReportTypes.SET_AC_REPORT_LOADER,
                reportLoader: false
            }
            dispatch(loaderEndAction);
        }
    } catch (error) {
        const loaderEndAction: Partial<UserAction> = {
            type: acReportTypes.SET_AC_REPORT_LOADER,
            loader: false
        }
        dispatch(loaderEndAction);
        console.error(error)
        throw error
    }
}

export const setAcReportListTableProps: any = (data,screen) => async (dispatch: (arg0: Partial<AcReportAction>) => void): Promise<void> => {
    if (screen === 'chargingHistory') {
        const action: Partial<AcReportAction> = {
            type: acReportTypes.SET_AC_CHARGING_HISTORY_LIST_TABLE_PROPS,
            chargingHistoryListTableProps: data,
        };
        dispatch(action);
      } else if (screen === 'chargerLogs') {
        const action = {
          type: acReportTypes.SET_AC_CHARGER_LOGS_LIST_TABLE_PROPS,
          chargerLogsListTableProps: data,
        }
        dispatch(action);
      }
      else if (screen === 'exceptionLogs') {
        const action = {
          type: acReportTypes.SET_AC_EXCEPTION_LOGS_LIST_TABLE_PROPS,
          exceptionLogsListTableProps: data,
        }
        dispatch(action);
      }
      else if (screen === 'sessionHistory'){
        const action: Partial<AcReportAction> = {
            type: acReportTypes.SET_AC_SESSION_HISTORY_LIST_TABLE_PROPS,
            sessionHistoryListTableProps: data,
        }
        dispatch(action);
      }
      else if (screen === 'statusHistory'){
        const action: Partial<AcReportAction> = {
            type: acReportTypes.SET_AC_STATUS_HISTORY_LIST_TABLE_PROPS,
            statusHistoryListTableProps: data,
        }
        dispatch(action);
      }
}

export const exportAcChargerLogsReport: any = (reqParams: unknown) => async () => {
    try {
        const { data, status } = await hwaxios.post(url + '/report/charging/history/export', reqParams)       
        return { data, status };
    } catch (error) {
        if (isAxiosError(error)) {
            if (error.response) {
                const data = error.response.data;
                const status = error.response.status;
                return { data, status };
            }
        } else {
            return {
                data: 'Something went wrong', status: 400
            }
        }
    }
}


export const fetchAcExceptionLogsData: any = (reqBody: unknown) => async (dispatch: (arg0: Partial<AcReportAction>) => void): Promise<void> => {
    try {
        const loaderStartAction: Partial<AcReportAction> = {
            type: acReportTypes.SET_AC_REPORT_LOADER,
            reportLoader: true
        }
        dispatch(loaderStartAction);
        const response = await hwaxios.post(url + '/log-dashboard', reqBody)
        const action: Partial<AcReportAction> = {
            type: acReportTypes.FETCH_AC_EXCEPTION_LOGS_DATA,
            exceptionLogsColumnHeaders: response.data?.columns,
            exceptionLogsData: response.data?.data?.logs,
            exceptionLogsCount: response.data?.data?.logCount,
        }
        dispatch(action)
        if (response?.status === 200) {
            const loaderEndAction: Partial<AcReportAction> = {
                type: acReportTypes.SET_AC_REPORT_LOADER,
                reportLoader: false
            }
            dispatch(loaderEndAction);
        }
    } catch (error) {
        const loaderEndAction: Partial<UserAction> = {
            type: acReportTypes.SET_AC_REPORT_LOADER,
            loader: false
        }
        dispatch(loaderEndAction);
        console.error(error)
        throw error
    }
}

// TODO: EXPORT EXCEPTION LOGS
export const exportAcExceptionLogs: any = (reqParams: unknown) => async () => {
    try {
        const { data, status } = await hwaxios.post(url + '/log-dashboard/export', reqParams)
        return { data, status };
    } catch (error) {
        if (isAxiosError(error)) {
            if (error.response) {
                const data = error.response.data;
                const status = error.response.status;
                return { data, status };
            }
        } else {
            return {
                data: 'Something went wrong', status: 400
            }
        }
    }
}


export const fetchAcStatusHistoryReportData: any = (reqBody: any) => async (dispatch: (arg0: Partial<AcReportAction>) => void): Promise<void> => {
    try {
        const loaderStartAction: Partial<AcReportAction> = {
            type: acReportTypes.SET_AC_REPORT_LOADER,
            reportLoader: true
        }
        dispatch(loaderStartAction);

        const filtersHash = reqBody?.filters
        const hashAction: Partial<AcReportAction> = {
            type: acReportTypes.SET_AC_STATUS_HISTORY_LIST_REQUEST_HASH,
            statusHistoryFiltersRequestHash: filtersHash
        }
        dispatch(hashAction)

        const response = await hwaxios.post(url + '/report/charger/status-history', reqBody)
        const action: Partial<AcReportAction> = {
            type: acReportTypes.FETCH_AC_STATUS_HISTORY_DATA,
            statusHistoryColumnHeaders: response.data?.columns,
            statusHistoryData: response.data?.data?.history,
            statusHistoryCount: response.data?.data?.count,
        }
        dispatch(action)

        if (response?.status === 200) {
            const loaderEndAction: Partial<AcReportAction> = {
                type: acReportTypes.SET_AC_REPORT_LOADER,
                reportLoader: false
            }
            dispatch(loaderEndAction);
        }
    } catch (error) {
        const loaderEndAction: Partial<AcReportAction> = {
            type: acReportTypes.SET_AC_REPORT_LOADER,
            reportLoader: false
        }
        dispatch(loaderEndAction);
        console.error(error)
        throw error
    }
}

export const exportAcStatusHistoryReport: any = (reqParams: unknown) => async () => {
    try {
        const { data, status } = await hwaxios.post(url + '/report/charger/status-history/export', reqParams)
        return { data, status };
    } catch (error) {
        if (isAxiosError(error)) {
            if (error.response) {
                const data = error.response.data;
                const status = error.response.status;
                return { data, status };
            }
        } else {
            return {
                data: 'Something went wrong', status: 400
            }
        }
    }
}

export const setAcRedirectedStateForStatusHistoryFilters: any = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        try {
            const action = {
                type: acReportTypes.SET_AC_STATUS_HISTORY_FILTERS_APPLIED_FROM_REDIRECTION,
                statusHistoryFiltersAppliedFromRedirection: data
            }
            dispatch(action)
            resolve({ message: 'Action dispatched successfully' })
        } catch (err) {
            reject(err)
        }
    })
}


